var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button",style:(_vm.styleObject),on:{"click":function($event){return _vm.goToSite()}}},[_c('i',{class:_vm.icon}),_c('p',{staticClass:"bttitle"},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }